<ion-toolbar
  [color]="disableBack ? 'white' : 'toolbar-blue-gradrient'"
  mode="md"
>
  <ng-container *ngIf="!disableBack">
    <div class="circle">
      <img [src]="header.icono" />
    </div>
  </ng-container>

  <ion-item lines="none" mode="md" class="ion-text-center">
    <ion-label
      class="label-header"
      [ngClass]="disableBack ? 'margin-top-header' : 'ion-no-margin'"
      [innerHTML]="header.texto | htmlSeguro"
    ></ion-label>
  </ion-item>
  <ng-container *ngIf="minutes > 0 && !isComplete">
    <ion-item lines="none" mode="md" class="ion-text-center">
      <ion-label
        class="label-header ion-no-margin"
        [innerHTML]="
          'Labels.time-execution' | translate : { timer: timer } | htmlSeguro
        "
      ></ion-label>
    </ion-item>
  </ng-container>
</ion-toolbar>
